import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import MyLayout from "layouts/my";
import AuthLayout from "layouts/auth";
import NotFound from "views/NotFound";

const getCookie = (name) => {
    const cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
        const cookiePair = cookies[i].split("=");
        const cookieName = cookiePair[0];
        const cookieValue = decodeURIComponent(cookiePair[1]);

        if (name.trim() === cookieName.trim()) {
            return cookieValue;
        }
    }

    return localStorage.getItem(name);
};

const App = () => {
    return (
        <Routes>
            <Route path="auth/*" element={<AuthLayout />} />
            <Route path="my/*" element={<MyLayout />} />
            <Route
                path="/"
                element={
                    getCookie("ACCESS_TOKEN") ? (
                        <Navigate to="/my" replace />
                    ) : (
                        <Navigate to="/auth" replace />
                    )
                }
            />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default App;
